// extracted by mini-css-extract-plugin
module.exports = {"header":"styles__header___3KD3n","submitter":"styles__submitter___1VO9P","name":"styles__name___bhdYO styles__submitter___1VO9P","status":"styles__status___2pJ7a"};